import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
  selector: 'sellions-percent-block',
  templateUrl: 'sellions-percent-block.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SellionsPercentBlockComponent {
  @Input() points;
  @Input() title;
  @Input('subtitle') subTitle;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/shared/components/sellions-percent-block/sellions-percent-block.ts